<template>
  <div class="vendors-list tab-table">
    <vendors-table :hide-actions="hideActions"/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import VendorsTable from "@/modules/vendors/VendorsTable";

  const {mapState} = createNamespacedHelpers('sales');
  const {mapActions: vendorsMapActions} = createNamespacedHelpers('vendors');

  export default {
    name: "VendorsList",
    components: {VendorsTable},
    data() {
      return {
        hideActions: [
        ],
      }
    },
    computed: {
      ...mapState({
        sale: state => state.view.currentSale
      })
    },
    methods: {
      ...vendorsMapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'sale',
        extraFilters: {auction_uuid: this.sale.uuid},
        sale: this.sale,
      });
    }
  }
</script>

<style lang="scss" scoped>
</style>
